import Big from 'big.js';

const HUNDRED = 100;

export const convertRateToPercentage = (rate: number): number => Big(rate).times(HUNDRED).toNumber();
export const convertPercentageToRate = (percentage: number): number => Big(percentage).div(HUNDRED).toNumber();
